import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

import GenAILoader from "./GenAI_Loader";

const useStyles = makeStyles(() => ({
  marvin_loader__container: {
    display: "flex",
    gap: "10px",
    alignItems: "center",

    "& .marvin_loader__sub_container": {
      width: "24px",
      height: "24px",
    },

    "& .m_text": {
      fontFamily: "Open Sans",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "16px",
      textAlign: "left",
      color: "#000",
    },
  },
}));

function MarvinLoader() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.marvin_loader__container}>
      <div className={"marvin_loader__sub_container"}>
        <GenAILoader />
      </div>
      <span className="m_text">{t("Regenerating")}</span>
    </div>
  );
}

export default MarvinLoader;
